import React, { useEffect } from "react";
import * as stdActions from "../../redux/actions/stdAction";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import Sidebar from "../../components/Sidebar";
import { setLanguage } from "redux-i18n";
import * as modalActions from "../../redux/actions/modalActions";
import * as commonActions from "../../redux/actions/commonAction";
import * as airAttachmentsAction from "../../redux/actions/airAttachmentsAction";
import * as attachmentsActions from "../../redux/actions/attachmentsAction";
import { initialPagination, airInitialPagination } from "../../App.config";
import AirApplicantComponent from "../../components/AirApplicant";

const AirApplicant = (props, context) => {
  const profileReducer = useSelector((state) => state.profileReducer);
  const commonReducer = useSelector((state) => state.commonReducer);
  const airAttachmentsReducer = useSelector(
    (state) => state.airAttachmentsReducer
  );

  const dispatch = useDispatch();
  const modalAction = bindActionCreators(modalActions, dispatch);
  const commonAction = bindActionCreators(commonActions, dispatch);
  const airAttachmentAction = bindActionCreators(
    airAttachmentsAction,
    dispatch
  );

  ///Set initial pagination and call api after first render
  useEffect(() => {
    airAttachmentAction.getAirEmployeebyManager(airInitialPagination, null);
  }, []);

  const searchByName = (name) => {
    airAttachmentAction.getAirEmployeebyManager(airInitialPagination, name);
    airAttachmentAction.setCurrentPage(airInitialPagination.pageNo);
    airAttachmentAction.setPageSize(airInitialPagination.pageSize);
  };

  const languageChange = (language) => {
    dispatch(setLanguage(language));
  };

  const onMenuToggle = (isOpen) => {
    commonAction.setIsSideMenuOpen(isOpen);
  };

  const openSetModal = (children) => {
    modalAction.openSetModal(children);
  };

  const closeRemoveModal = () => {
    modalAction.closeRemoveModal();
  };

  const setFilteredApplicants = (filteredApplicants) => {
    airAttachmentAction.setFilteredApplicants(filteredApplicants);
  };

  const onChange = (page) => {
    airAttachmentAction.setCurrentPage(page.value);
    airAttachmentAction.getEmployeebyManager(
      {
        pageNo: page.value,
        pageSize: airAttachmentsReducer.pageSize,
        totalRows: airAttachmentsReducer.totalRows,
      },
      page.searchKey
    );
  };

  return (
    <>
      {window.location.hash !== "#/" && (
        <Sidebar
          languageChange={languageChange}
          openSetModalAction={openSetModal}
          closeRemoveModal={closeRemoveModal}
          managersDetails={profileReducer.managersDetails}
          onMenuToggle={onMenuToggle}
          isSideMenuOpen={commonReducer.isSideMenuOpen}
          context={context}
        />
      )}
      <div className="Content-Panel">
        <AirApplicantComponent
          setFilteredApplicants={setFilteredApplicants}
          applicants={airAttachmentsReducer.applicants}
          // filteredApplicants={airAttachmentsReducer.filteredApplicants}
          currentPage={airAttachmentsReducer.currentPage}
          pageSize={airAttachmentsReducer.pageSize}
          totalRows={airAttachmentsReducer.totalRows}
          searchByName={searchByName}
          openSetModal={openSetModal}
          closeRemoveModal={closeRemoveModal}
          // onPageSizeChange={onPageSizeChange}
          onChange={(props) => {
            onChange(props);
          }}
        />
      </div>
    </>
  );
};

AirApplicant.contextTypes = {
  t: PropTypes.func.isRequired,
};
export default AirApplicant;
